import React, { useState, useEffect } from "react";
import { withRouter, useLocation } from "react-router-dom";
import { Typography, message, Carousel, Button, Row, Col, Card, Icon } from "antd";
import { platformApi } from "../../../../api";
import { LeftOutlined } from "@ant-design/icons";
import moment from "moment";
import CustomerInfo from "../../../FollowUp/CustomerInfo";
import ActivityLog from "../../../FollowUp/ActivityLog";
import WrappedCallingInterface from "../../../FollowUp/QuotationInfo/CallingInterface";
import ServiceInvoiceTable from "./ServiceInvoiceTable";
import FeedbackModal from "./FeedbackModal";

const { Title } = Typography;

const ServiceFeedbackCallDetails = (props) => {
  const { history, match } = props;
  const phoneNumber = match.params.phone;

  const [allCustomers, setCustomers] = useState([]);
  const [customerDetails, setCustomerDetails] = useState(null);
  const [customerId, setCustomerId] = useState(null);
  const [customerIds, setCustomerIds] = useState([]);
  
  const [serviceInvoices, setServiceInvoices] = useState([]);
  const [activities, setActivities] = useState([]);
  
  const [callModal, setCallModal] = useState(false);
  const [feedbackModal, setFeedbackModal] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);

  const [activeTab, setActiveTab] = useState(props.location?.state?.status || ""); 

  const changeRecord = (next = false) => {
    platformApi.post("/api/jobInvoice/scheduled", {
      status: activeTab,
      jobStatus: ["PAID"],
      phone: phoneNumber,
      next
    }).then(res => {
      const { data } = res;
      if (data.code === 200 && data.response.data?.partyName?.contacts) {
        const nextRecord = data.response.data;
        const phno = nextRecord.partyName?.contacts?.find(c => c.type === "Primary")?.phone || nextRecord.partyName?.contacts?.[0]?.phone;
        if (phno) {
          history.push({
            pathname: `/autoadmin/service_feedback_call/${phno}`,
            state: {
              jobInvoiceId: nextRecord.id,
              status: activeTab,
              jobStatus: ["PAID"]
            }
          });
          message.success("Record Fetched !!!");
        } else {
          message.error("Contact details not found for next record");
        }
      } else {
        message.info(next ? "No Next Record Exist" : "No Previous Record Exist");
      }
    }).catch(err => {
      message.error("Unable to fetch record");
    });
  };

  useEffect(() => {
    getCustomersByPhone(phoneNumber);
  }, [phoneNumber]);

  const getCustomersByPhone = (phoneNo) => {
    platformApi.get(`/api/customer/phone-no/${phoneNo}`)
      .then((res) => {
        const { data: { response: { data: { customers } } } } = res;
        setCustomers(customers);
        if (customers.length) {
          const ids = customers.map((c) => c.id || c.customerId);
          setCustomerIds(ids);
          setCustomerId(customers[0].id || customers[0].customerId);
          getCustomerInfo(customers[0].id || customers[0].customerId);
          getServiceInvoices(phoneNo);
          getActivityByCustomer(ids);
        }
      })
      .catch((err) => {
        message.error("Unable to get customer details");
      });
  };

  const getCustomerInfo = (id) => {
    platformApi.get(`/api/customer/${id}`).then((res) => {
      setCustomerDetails(res.data.response.data);
    });
  };

  const getServiceInvoices = (phone) => {
    platformApi.post("/api/jobInvoice/get", {
      page: 1,
      size: 100,
      jobStatus: ["PAID"],
      searchString: phone,
    }).then((res) => {
      const { data } = res;
      if (data.code === 200) {
        setServiceInvoices(data.response.data.saleSpareInvoice || []);
      }
    });
  };

  const getActivityByCustomer = (ids = customerIds) => {
    platformApi.post("/api/activity/customers", {
      limit: 100,
      offset: 0,
      ids: ids,
    }).then((res) => {
      const { data: { response: { data } } } = res;
      const filtered = data.filter(act => act.activityType === "Service Feedback");
      setActivities(filtered);
    }).catch(err => {
      // message.error("Unable to get activities");
    });
  };

  const updateCustomerData = (customer) => {
    platformApi.put(`/api/customer/${customer.id}`, customer)
      .then((res) => {
        if (res.data.code === 200) {
          message.success("Customer updated successfully");
          getCustomerInfo(customer.id);
        }
      });
  };

  const handleInvoiceView = (record) => {
    window.open(`/autoadmin/job_invoice/${record.id}`, "_blank");
  };

  const handleCallIconClick = (record) => {
    setSelectedInvoice(record);
    setCallModal(true);
  };

  const handleFeedbackClick = (record) => {
    setSelectedInvoice(record);
    setFeedbackModal(true);
  };

  return (
    <div className="service-feedback-call-details" style={{ padding: 20 }}>
      <Row type="flex" justify="space-between" align="middle" style={{ marginBottom: 20 }}>
        <Col>
          <Title level={4}>
            <Button
              style={{ marginRight: 20 }}
              onClick={() => history.push("/autoadmin/service_feedback_call")}
            >
              <LeftOutlined />
            </Button>
            Service Feedback Call
          </Title>
        </Col>
      </Row>

      <Row type="flex" justify="space-between" style={{ marginBottom: 16 }}>
        <Col>
          <Button style={{ marginLeft: 20 }} onClick={() => changeRecord(false)}>Previous</Button>
        </Col>
        <Col>
          <Button style={{ marginRight: 20 }} onClick={() => changeRecord(true)}>Next</Button>
        </Col>
      </Row>

      <Card>
        <Row type="flex" gutter={[16, 16]} align="middle">
          <Col span={6}>
            <Carousel
              dots={false}
              beforeChange={(from, to) => {
                const nextCust = allCustomers[to];
                if (nextCust) {
                  setCustomerId(nextCust.id || nextCust.customerId);
                  getCustomerInfo(nextCust.id || nextCust.customerId);
                }
              }}
            >
              {allCustomers.map((cust) => (
                <div key={cust.id}>
                  {customerDetails && customerDetails.id === cust.id ? (
                    <CustomerInfo
                      customer={customerDetails}
                      setCustomer={setCustomerDetails}
                      updateCustomerData={updateCustomerData}
                    />
                  ) : (
                    <div style={{ height: 220, background: "#f0f2f5", display: "flex", alignItems: "center", justifyContent: "center" }}>
                      Loading Cust Info...
                    </div>
                  )}
                </div>
              ))}
            </Carousel>
          </Col>
          
          <Col span={14}>
            <ServiceInvoiceTable 
              dataSource={serviceInvoices} 
              onView={handleInvoiceView}
            />
          </Col>

          <Col span={4} style={{ textAlign: "center" }}>
            {serviceInvoices.length > 0 && (
              serviceInvoices[0].status === "FEEDBACK_COMPLETED" ? (
                <Button type="primary" onClick={() => handleFeedbackClick(serviceInvoices[0])}>
                  Feedback
                </Button>
              ) : (
                <Button 
                  shape="circle" 
                  size="large" 
                  icon="phone" 
                  style={{ fontSize: 24, height: 60, width: 60, color: "#1890ff" }}
                  onClick={() => handleCallIconClick(serviceInvoices[0])}
                />
              )
            )}
          </Col>
        </Row>
      </Card>

      <div style={{ marginTop: 20 }}>
        <ActivityLog 
          customerId={customerId}
          dataSource={activities}
          getActivityByCustomer={getActivityByCustomer}
        />
      </div>

      {/* Modals */}
      <WrappedCallingInterface 
        visibility={callModal}
        setVisibility={setCallModal}
        customerDetail={customerDetails}
        getActivityByCustomer={getActivityByCustomer}
        activityType="Service Feedback"
        isFeedbackCall={true}
        saleRegisterId={selectedInvoice?.id}
        feedbackApi="/api/jobInvoice/saveFeedback"
      />

      <FeedbackModal 
        visible={feedbackModal}
        onCancel={() => setFeedbackModal(false)}
        jobInvoice={selectedInvoice}
        onSaveSuccess={() => {
          getServiceInvoices(phoneNumber);
          getActivityByCustomer();
        }}
      />
    </div>
  );
};

export default withRouter(ServiceFeedbackCallDetails);
